import { metaTagsContact } from "@/content";
import { MetaTags } from "@/lib";
import ContentTitles from "@/ui/content-titles/content-titles";
import ContactUsBlock from "@/ui/contact-us-block";
import GoogleReviews from "@/ui/google-reviews/google-reviews";
import { GoogleServiceArea } from "@/ui/google-service-area/GoogleServiceArea";
import { serviceBlockData } from "@/content/services/stand-alone-services";
import ServiceBlock from "@/ui/service-block/ServiceBlock";
import React from "react";

export default function ContactPage() {
    return (
        <div className='bg-grey[50]'>
            <MetaTags metaTags={metaTagsContact} />
            <div className="grid">
                <div className="col-span-12">
                    <div className="py-3 px-3 md:px-0">
                        <ContentTitles
                            title="Get in touch"
                            // subTitle="Contact us using the details below or follow us on our socials."
                        />
                        <div className="py-5">
                            <ContactUsBlock />
                        </div>
                    </div>
                    <div className="mb-5 mx-3">
                        <GoogleServiceArea />
                    </div>
                </div>
            </div>
            <ServiceBlock data={serviceBlockData} />
            <div className="mb-3">
                <GoogleReviews />
            </div>
        </div>
    );
}
